import { useEffect, useState, Suspense } from "react";
import Snowfall from "react-snowfall";

// Importa las imágenes para los nuevos efectos (debes agregarlas a tu proyecto)
import leafImage from "assets/images/seasonal/autumn-leaf.webp"; // Ejemplo
import petalImage from "assets/images/seasonal/sakura-petal.png"; // Ejemplo

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Presentation from "layouts/pages/presentation";

// Material Kit 2 React routes
import routes from "routes";

export default function App() {
  const { pathname } = useLocation();
  const [seasonalEffect, setSeasonalEffect] = useState(null);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    const now = new Date();
    const month = now.getMonth() + 1; // Meses son 0-indexados, +1 para tener 1-12

    // Lógica para determinar el efecto estacional
    if (month === 12 || month === 1 || month === 2) {
      // Invierno: Nieve (efecto por defecto de Snowfall)
      setSeasonalEffect({ type: "snow" });
    } else if (month >= 3 && month <= 5) {
      // Primavera: Pétalos de cerezo
      const petal = document.createElement("img");
      petal.src = petalImage;
      setSeasonalEffect({ type: "petals", images: [petal] });
    } else if (month >= 9 && month <= 11) {
      // Otoño: Hojas
      const leaf = document.createElement("img");
      leaf.src = leafImage;
      setSeasonalEffect({ type: "leaves", images: [leaf] });
    } else {
      // Sin efecto para otros meses
      setSeasonalEffect(null);
    }

    // --- Ejemplo de cómo podrías manejar una fecha específica como Fiestas Patrias ---
    // const day = now.getDate();
    // if (month === 9 && day >= 14 && day <= 16) {
    //   // Lógica para confeti
    //   setSeasonalEffect({ type: "confetti", ... });
    // }

    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <div>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Suspense
          fallback={
            <MKBox display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
              <MKTypography variant="h4">Cargando...</MKTypography>
            </MKBox>
          }
        >
          <Routes>
            {getRoutes(routes)}
            <Route path="/inicio" element={<Presentation />} />
            <Route path="*" element={<Navigate to="/inicio" />} />
          </Routes>
        </Suspense>
      </ThemeProvider>
      {seasonalEffect && (
        <Snowfall
          // Cambia los props según el efecto
          color={seasonalEffect.type === "snow" ? "white" : undefined}
          images={seasonalEffect.images}
          radius={seasonalEffect.type === "snow" ? [1.0, 3.0] : [12.0, 25.0]}
          snowflakeCount={seasonalEffect.type === "snow" ? 100 : 40} // Menos partículas para hojas/pétalos
          speed={seasonalEffect.type === "snow" ? [0.5, 3.0] : [0.2, 1.0]}
          style={{ zIndex: 9999 }}
        />
      )}
    </div>
  );
}
